import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { ConsentType } from "../../models/consent-type.model";
import { Feature } from "../../models/feature.model";
import { PermissionCheck } from "../../shared/permission";
import { FeatureService } from "../../services/feature.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { ConsentTypeDataProvider } from "../../data-provider/consent-type.dp";

let ConsentTypeSettingsComponent = {
    selector: "vcConsentTypeSettings",
    templateUrl:
        "/angular/components/consent-type/consent-type-settings.component.html",
    bindings: {},
    controller: class ConsentTypeSettingsController {
        private $scope: any;
        private $q: any;
        private dataProvider: ConsentTypeDataProvider;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private featureService: FeatureService;

        public permissionProvider: PermissionCheck;
        public consent: Feature;
        public consentTypes: ConsentType[];
        public activeCampaign: Campaign;

        constructor(
            $scope: any,
            $q: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            ConsentTypeDataProvider: ConsentTypeDataProvider,
            FeatureService: FeatureService
        ) {
            this.$scope = $scope;
            this.$q = $q;
            this.featureService = FeatureService;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.permissionProvider = PermissionCheck;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.dataProvider = ConsentTypeDataProvider;

            this.permissionProvider.getConsentSettings().then((settings) => {
                this.consent = new Feature(
                    this.$q,
                    this.featureService,
                    settings.CONSENT.attributes
                );
            });

            this.dataProvider.all().then((consentTypes: ConsentType[]) => {
                this.consentTypes = consentTypes;
            });
        }

        setEnabled(bool) {
            this.consent.setEnabled(bool);
            this.permissionProvider.updateFeaturePermission(this.consent);
        }

        activeStatuses() {
            return this.consentTypes.filter(function (item) {
                return item.status == "Active";
            });
        }

        openMinStatusesDialog(ev) {
            let dialog = this.dialog
                .alert()
                .textContent(
                    "Sorry but you need to keep at least 1 active consent type. If you don't want to capture consent you can disable this feature"
                )
                .targetEvent(ev)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(dialog);
        }

        deleteConsentType(consentType, ev) {
            if (
                this.activeStatuses().length <= 1 &&
                consentType.status === "Active"
            ) {
                this.openMinStatusesDialog(ev);
            } else {
                this.dialog
                    .delete({
                        targetEvent: ev,
                        locals: {
                            bodyText:
                                "Are you sure you want to permanently delete this consent type? It will be removed from the apps, database page, and any no longer appear on the contact screen.",
                            title: `Delete Consent Type?`,
                        },
                    })
                    .then(() => {
                        this.dataProvider.delete(consentType).then(
                            () => {
                                this.toast.success("Consent type deleted");
                                this.dataProvider
                                    .all()
                                    .then((consentTypes: ConsentType[]) => {
                                        this.consentTypes = consentTypes;
                                    });
                            },
                            () => this.toast.error()
                        );
                    });
            }
        }

        toggleActive(consentType, ev) {
            if (
                consentType.status == "Active" &&
                this.activeStatuses().length <= 1
            ) {
                this.openMinStatusesDialog(ev);
            } else {
                let body, heading;
                if (consentType.status === "Active") {
                    heading = "Deactivate Consent Type?";
                    body =
                        "This will not show up on the apps anymore. However, it will still be available as a filter option on the database page," +
                        " and will be listed on the contact screen of any contact who previously consented to this type of contact.";
                } else {
                    heading = "Activate Consent Type?";
                    body =
                        "This will now show up on the Walk & Go apps, allowing users to capture consent for this form on contact.";
                }

                this.dialog
                    .delete({
                        targetEvent: ev,
                        locals: {
                            bodyText: body,
                            title: heading,
                        },
                    })
                    .then(() => {
                        consentType.status =
                            consentType.status === "Active"
                                ? "Deactivated"
                                : "Active";
                        this.dataProvider.update(consentType).then(
                            () => this.toast.success("Consent type updated"),
                            () => this.toast.error()
                        );
                    });
            }
        }

        openConsentTypeDialog(ev) {
            this.dialog
                .show({
                    component: "vc-create-consent-type",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {},
                })
                .then((consentType) => {
                    this.dataProvider.create(consentType).then(
                        () => {
                            this.toast.success("Consent type created");
                            this.dataProvider
                                .all()
                                .then((consentTypes: ConsentType[]) => {
                                    this.consentTypes = consentTypes;
                                });
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("consentType", [])
    .component(
        ConsentTypeSettingsComponent.selector,
        ConsentTypeSettingsComponent
    );
